<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpFormGroup
    name="name"
    :label="'Name'|pgettext('Employee')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    required
  >
    <ItpFormInput
      name="name"
      v-model="employee.name"
      required
      autofocus
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="job_title"
    :label="'Job Title'|pgettext('Employee')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
  >
    <ItpFormInput
      name="job_title"
      v-model="employee.job_title"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="phone"
    :label="'Phone Number'|pgettext('Employee')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
  >
    <ItpFormInput
      name="phone"
      v-model="employee.phone"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="mobile"
    :label="'Mobile Number'|pgettext('Employee')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
  >
    <ItpFormInput
      name="mobile"
      v-model="employee.mobile"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="email"
    :label="'Email'|pgettext('Employee')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
  >
    <ItpFormInput
      name="email"
      v-model="employee.email"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="fax"
    :label="'Fax'|pgettext('Employee')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
  >
    <ItpFormInput
      name="fax"
      v-model="employee.fax"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="notes"
    :label="'Notes'|pgettext('Employee')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
  >
    <ItpFormTextarea
      name="notes"
      v-model="employee.notes"
    >
    </ItpFormTextarea>
  </ItpFormGroup>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcEmployeeFieldset extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  employee!: object;

  @Watch('employee')
  onEmployee(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("employee")
  }

  @Prop({
    type: String,
    default: "right",
  })
  labelAlign!: string;

  @Watch('labelAlign')
  onLabel_align(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("labelAlign")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_8316: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_8315: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_8316 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_8315 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_8316,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_8315],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_8316,
      evh_7315092382398562_reload_8315,
      evh_7315092382398562_reload,
    }
  }
}

Vue.component("UcEmployeeFieldset", UcEmployeeFieldset);

</script>